import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";


interface SelectDropdownTkProjProps {
  onProjectChanged: (projectId: number | null) => void;
  selectedProjectId?: number | null;
  isDisabled: boolean;
}

const SelectDropdownTkProj = ({ selectedProjectId, onProjectChanged, isDisabled }: SelectDropdownTkProjProps) => {
  const [projectDll, setProjectDll] = useState<any[]>([]);
  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.GET_DLL_VALUE_TKPROJECT)
        .then(rs => {
          // console.log('GET_DLL_VALUE_TKPROJECT:', rs);
          // console.log('selectedProjectId = ' + selectedProjectId);
          setProjectDll(rs);

        })
        .catch(e2 => Utils.HandleException(e2, false));
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }, []);

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      list={projectDll}
      onValueChanged={onProjectChanged}
      selectedValue={projectDll.find(e => e.value == selectedProjectId) ?? null}
    />
  )
}

export default SelectDropdownTkProj

